<template>
    <div class="order-gift-card row">
        <div v-if="basket" class="col">
            <h4>2. Do you have a Gift Voucher?</h4>

            <div class="form-row">
                <div class="col-8">
                    <input v-model="giftCard" type="text" class="form-control mr-2" :disabled="loading"
                           placeholder="Enter code" maxlength="14">
                </div>
                <div class="col-4">
                    <button @click="applyGiftCard()" class="btn btn-secondary" :disabled="loading">Apply
                    </button>
                </div>
            </div>

            <div v-if="basket.gift_cards">
                <p v-for="giftCard in basket.gift_cards" :key="giftCard.id">
                    <a :key="giftCard.id" @click="removeGiftCard(giftCard.id)" href="javascript:;">{{ giftCard.code }}
                        (£{{ giftCard.amount_pending|money }}) applied - click to remove</a>
                </p>
            </div>

            <div v-if="error" class="alert alert-danger compact mt-4">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../../app";
export default {
    data() {
        return {
            loading: false,
            giftCard: null,
            error: null,
        };
    },

    props: {
        basket: {
            type: Object,
        },
    },

    watch: {
        //
    },

    mounted() {
        //
    },

    methods: {
        applyGiftCard() {
            this.loading = true;
            this.error = null;
            document.querySelector("button#continueButton").disabled = true;

            axios.post('/payment/create/GiftCard', {
                'code': this.giftCard,
            })
                .then(res => {
                    if (res.data && res.data.success) {
                        this.$root.basket = res.data.basket;
                        this.error = null;
                        this.giftCard = null;
                    } else {
                        this.error = res.data.error;
                    }
                })
                .catch(err => {
                    this.error = 'Sorry, an unexpected error occurred. Please try again later.';
                })
                .finally(() => {
                    this.loading = false;
                    document.querySelector("button#continueButton").disabled = false;
                    EventBus.$emit('giftCardAdded');
                });
        },

        removeGiftCard(giftCardId) {
            this.loading = true;
            this.error = null;
            document.querySelector("button#continueButton").disabled = true;

            axios.post('/payment/remove/GiftCard', {
                gift_card_id: giftCardId
            })
                .then(res => {
                    if (res.data && res.data.success) {
                        this.$root.basket = res.data.basket;
                    } else {
                        this.error = res.data.error;
                    }
                })
                .catch(err => {
                    this.error = 'Sorry, an unexpected error occurred. Please try again later.';
                })
                .finally(() => {
                    this.loading = false;
                    document.querySelector("button#continueButton").disabled = false;
                });
        },
    },
};
</script>
